import styled from 'styled-components';

export const StyledLegalEyebrow = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand-green);
  margin-bottom: 10px;
`;

export const StyledLegalTitle = styled.h1`
  margin: 0;
  font-size: var(--t-3xl);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--ink);
`;

export const StyledLegalUpdated = styled.p`
  margin: 10px 0 0;
  font-size: var(--t-sm);
  color: var(--muted-2);
`;

export const StyledLegalIntro = styled.p`
  margin: 28px 0 0;
  font-size: var(--t-lg, 1.0625rem);
  line-height: 1.6;
  color: var(--muted);
`;

export const StyledLegalSection = styled.section`
  margin-top: 36px;
`;

export const StyledLegalHeading = styled.h2`
  margin: 0 0 12px;
  font-size: var(--t-lg);
  font-weight: 700;
  color: var(--ink);
`;

export const StyledLegalParagraph = styled.p`
  margin: 0 0 12px;
  font-size: var(--t-base);
  line-height: 1.7;
  color: var(--ink);

  &:last-child { margin-bottom: 0; }
`;
